import React from "react";
import { EnhancedBulb } from "assets/img/svg/svgComponents/BulbIcon";
const currentTips = [
  "Upload cash receipts within 4 days for seamless experience.",
  "Ensure deposit slip is uploaded before the cutoff time.",
  "Check pending approvals regularly.",
];
const TipsSidebar = ({tips = currentTips}) => {
  return (
    <div className="tips-container">
      <div className="tips-icon-box">
        <EnhancedBulb />
      </div>

      <div className="tips-content">
        <div className="tips-title">Tips</div>
        <ul>
          {tips.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TipsSidebar;
